
import React, { ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface ResellerStatCardProps {
  title: string;
  bgClass: string;
  borderClass: string;
  titleColor: string;
  value: ReactNode;
  description: string;
  icon: ReactNode;
  details?: React.ReactNode[];
}

const ResellerStatCard: React.FC<ResellerStatCardProps> = ({
  title,
  bgClass,
  borderClass,
  titleColor,
  value,
  description,
  icon,
  details
}) => {
  return (
    <Card className={`${bgClass} ${borderClass}`}>
      <CardHeader className="pb-2">
        <CardTitle className={titleColor}>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <h3 className="text-xl font-bold">{value}</h3>
        <p className="text-gray-600 text-sm mt-1 mb-3">{description}</p>
        
        {details && details.map((detail, index) => (
          <div key={index} className="flex items-center mt-2">
            {icon}
            <span className="text-sm">{detail}</span>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default ResellerStatCard;
